<div class="m-1">
	<button
		class="map_button"
		matTooltip="{{ options.tooltip | translate }}"
		matTooltipClass="tooltip-map-button"
		matTooltipPosition="right"
		[class.map-button-active]="options.active"
	>
		{{ options.title }}
	</button>
</div>
